import {
  FC,
  MouseEvent,
  ReactElement,
  TouchEvent,
  useCallback,
  useState
} from 'react';
import { useTheme, Tooltip } from '@material-ui/core';
import { useStyles } from './useStyles';

export type TProps = {
  title?: ReactElement<any, any>;
  children: ReactElement<any, any>;
};

export const PositionalToolTip: FC<TProps> = props => {
  const { title, children } = props;

  const classes = useStyles();
  const theme = useTheme();

  // tooltipをマウスに合わせて移動させる用
  const [mousePositionOnToolTip, setMousePositionOnToolTip] = useState({
    pageX: 0,
    pageY: 0
  });
  const handleMouseMoveOnToolTip = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      const { pageX, pageY } = event;
      setMousePositionOnToolTip({ pageX, pageY });
    },
    []
  );
  const handleTouchOnToolTip = useCallback((event: TouchEvent<HTMLElement>) => {
    const { pageX, pageY } = event.changedTouches[0];
    setMousePositionOnToolTip({ pageX, pageY });
  }, []);

  const computeToolTipPosition = (data: any) => {
    // ツールチップの表示位置設定。sm以上の場合はマウスに追従、そうでない場合は横幅中央に表示
    let top = mousePositionOnToolTip.pageY - 2;
    let left = mousePositionOnToolTip.pageX + 7;
    if (window.innerWidth < theme.breakpoints.values.sm) {
      top = data.popper.top;
      left = window.innerWidth / 2 - data.popper.width / 2;
    }

    return {
      ...data,
      styles: {
        ...data.styles,
        left: `${left}px`,
        top: `${top}px`
      }
    };
  };

  return (
    <Tooltip
      title={<div className={classes.toolTip}>{title || children}</div>}
      onMouseMove={handleMouseMoveOnToolTip}
      onTouchStartCapture={handleTouchOnToolTip}
      leaveTouchDelay={100}
      enterTouchDelay={200}
      PopperProps={{
        modifiers: {
          computeStyle: {
            fn: computeToolTipPosition
          }
        }
      }}
    >
      {children}
    </Tooltip>
  );
};
